import VarType from "@/model/types/resource/VarType";
import InputType from "@/model/types/resource/InputType";
import ui from "@/assets/scripts/ui";

export default {
    data() {
        return {}
    },
    props: {},
    async mounted() {


    },
    methods: {

        getParamTextByItem(item, index) {

            const fieldValue = item['field' + index]
            const fieldType = item['field' + index + 'Type']
            const fieldVar = item['field' + index + 'Var']

            let text = ''
            let value = null

            if (fieldVar === VarType.type.BOOLEAN || fieldVar === VarType.type.INTEGER) {

                let v = fieldValue?.integerValue
                value = (v !== null && v !== undefined) ? v : 0

            } else if (fieldVar === VarType.type.DOUBLE) {

                let v = fieldValue?.doubleValue
                value = (v !== null && v !== undefined)
                    ? ui.convertNumber(v, 4, "pt-br")
                    : ui.convertNumber(0, 4, "pt-br")

            } else if (fieldVar === VarType.type.STRING) {

                let v = fieldValue?.stringValue
                value = (v !== null && v !== undefined) ? v : ""

            } else if (fieldVar === VarType.type.DATE) {

                let v = fieldValue?.dateValue
                value = (v !== null && v !== undefined)
                    ? ui.convertDateBR(v)
                    : ""

            }

            if (InputType.isList(fieldType)) {

                let options = item['field' + index + 'Options']

                if (options !== null && options !== undefined) {

                    options = options.split(";")

                    for (const o of options) {

                        const option = o.split(":")

                        let optionValue
                        const optionText = option[1]

                        if (fieldType === VarType.type.INTEGER) {
                            optionValue = parseInt(option[0])
                        } else {
                            optionValue = "" + option[0]
                        }

                        if (value === optionValue) {
                            text = optionText
                            break
                        }

                    }

                }

            } else {

                text = value

            }

            return text

        },


    },


}


